var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107543604,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 20854,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 972.8C260.266667 972.8 51.2 763.733333 51.2 512S260.266667 51.2 512 51.2 972.8 260.266667 972.8 512 763.733333 972.8 512 972.8z m0-853.333333c-217.6 0-392.533333 174.933333-392.533333 392.533333s174.933333 392.533333 392.533333 392.533333 392.533333-174.933333 392.533333-392.533333-174.933333-392.533333-392.533333-392.533333z",
    "p-id": 20855,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M640 716.8c-12.8 0-25.6-8.533333-29.866667-21.333333L512 430.933333l-98.133333 260.266667c-4.266667 17.066667-25.6 25.6-42.666667 17.066667-17.066667-4.266667-25.6-25.6-17.066667-42.666667l128-341.333333c4.266667-12.8 17.066667-21.333333 29.866667-21.333334s25.6 8.533333 29.866667 21.333334l128 341.333333c4.266667 17.066667-4.266667 34.133333-17.066667 42.666667-4.266667 4.266667-8.533333 8.533333-12.8 8.533333z",
    "p-id": 20856,
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M597.333333 631.466667h-170.666666c-17.066667 0-34.133333-12.8-34.133334-34.133334s12.8-34.133333 34.133334-34.133333h170.666666c17.066667 0 34.133333 12.8 34.133334 34.133333s-17.066667 34.133333-34.133334 34.133334z",
    "p-id": 20857,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/a.06b2c3fbd95cd14f392735c10af6cd4d.svg";
export { ForwardRef as ReactComponent };